/* ==========================================================================
   VilosTierland – Theme JavaScript (Vanilla JS, keine Abhängigkeiten)
   Module: Drawer · Warenkorb (AJAX) · Produktseite (Variantenwechsel)
           Suche · Futter-Erinnerung-Fokusfalle · Empfehlungen
   ========================================================================== */
(function () {
  'use strict';

  var VILOS = window.VILOS || {};
  var R = VILOS.routes || {};
  var S = VILOS.strings || {};
  var doc = document;
  var root = doc.documentElement;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  var toastTimer;
  function toast(message, isError) {
    var el = $('.toast');
    if (!el) { el = doc.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); doc.body.appendChild(el); }
    el.textContent = message;
    el.classList.toggle('toast--error', !!isError);
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3800);
  }

  /* ---------- Drawer ---------- */
  var lastTrigger = null;
  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    lastTrigger = trigger || doc.activeElement;
    drawer.classList.add('is-open');
   drawer.setAttribute('aria-hidden', 'false');
     root.classList.add('no-scroll');
           $$('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var f = $('[data-drawer-focus]', drawer); if (f) f.focus(); }, 60);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    root.classList.remove('no-scroll');
    $$('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  function openDrawers() { return $$('.drawer.is-open'); }

  /* ---------- Warenkorb ---------- */
  var cartReq = 0;
  var timers = {};

  function cartFetch(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || S.error);
          return data;
        });
      });
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 260);
    });
  }
  function swapDrawer(html) {
    var fresh = $('[data-cart-drawer-content]', parseHTML(html));
    var current = $('[data-cart-drawer-content]');
    if (!fresh || !current) return;
    var body = $('.drawer__body', current);
    var top = body ? body.scrollTop : 0;
    current.innerHTML = fresh.innerHTML;
    initAll(current);
        var nb = $('.drawer__body', current);
    if (nb) nb.scrollTop = top;
  }
  function swapMain(html) {
    var fresh = $('[data-main-cart]', parseHTML(html));
    var current = $('[data-main-cart]');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    initAll(fresh);
  }
  function refreshCart() {
    var id = ++cartReq;
    var onCartPage = !!$('[data-main-cart]'), mainSec = onCartPage && $('[data-main-cart]').closest('[id^="shopify-section-"]'), mainId = mainSec ? mainSec.id.replace('shopify-section-', '') : null;
    var sections = 'cart-drawer' + (mainId ? ',' + mainId : '');
    return Promise.all([
      fetch(R.cart_js, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }),
      fetch(R.cart + '?sections=' + sections).then(function (r) { return r.json(); })
    ]).then(function (out) {
      if (id !== cartReq) return;
      updateCount(out[0].item_count);
      if (out[1]['cart-drawer']) swapDrawer(out[1]['cart-drawer']);
      if (mainId && out[1][mainId]) swapMain(out[1][mainId]);
    }).catch(function () {});
  }
  function changeLine(line, quantity) {
    $$('[data-cart-line="' + line + '"]').forEach(function (el) { el.classList.add('is-updating'); });
    return cartFetch(R.cart_change, { line: Number(line), quantity: Number(quantity) })
      .then(refreshCart)
      .catch(function (err) { toast(err.message || S.error, true); return refreshCart(); });
  }
  function queueLineChange(line, quantity) {
    clearTimeout(timers[line]);
    timers[line] = setTimeout(function () { changeLine(line, quantity); }, 350);
  }
  function addToCart(form) {
    var btn = $('[data-add-to-cart]', form);
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var errorBox = $('[data-form-error]', form);
    if (!idField || !idField.value) return;
    if (errorBox) errorBox.hidden = true;
    if (btn) btn.classList.add('is-loading');

    cartFetch(R.cart_add, { id: Number(idField.value), quantity: qtyField ? Math.max(1, Number(qtyField.value) || 1) : 1 })
      .then(function () {
        if (VILOS.cartType === 'page') { window.location.href = R.cart; return null; }
        return refreshCart().then(function () { var drawer = $('#CartDrawer'); if (drawer) openDrawer(drawer, btn); });
      })
      .catch(function (err) {
        var msg = err.message || S.error;
        if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else { toast(msg, true); }
      })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- Produktseite (Variantenwechsel) ---------- */
  function showMedia(scope, id) {
    $$('.gallery__item', scope).forEach(function (el) { el.classList.toggle('is-active', String(el.getAttribute('data-media-id')) === String(id)); });
    $$('.gallery__thumb', scope).forEach(function (el) { el.classList.toggle('is-active', String(el.getAttribute('data-thumb')) === String(id)); });
  }
  function markUnavailableOptions(scope, variants, selected) {
    $$('.opt', scope).forEach(function (fs, i) {
      $$('[data-option-input]', fs).forEach(function (input) {
        var ok = variants.some(function (v) {
          return v.available && v.options[i] === input.value && v.options.every(function (o, j) { return j === i || o === selected[j]; });
        });
        input.classList.toggle('is-unavailable', !ok);
      });
    });
  }
  function onVariantChange(rootEl) {
    var dataEl = $('[data-variants]', rootEl);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selected = $$('.opt', rootEl).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    markUnavailableOptions(rootEl, variants, selected);
    var variant = null;
    variants.forEach(function (v) { if (v.options.every(function (o, i) { return o === selected[i]; })) variant = v; });
    var btn = $('[data-add-to-cart]', rootEl);
    var idInput = $('[data-variant-id]', rootEl);
    if (!variant) { if (btn) { btn.disabled = true; var lbl = $('span', btn); if (lbl) lbl.textContent = S.sold_out; } return; }
    if (idInput) idInput.value = variant.id;
    if (window.history && history.replaceState) {
      var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url.toString());
    }
    if (variant.featured_media && variant.featured_media.id) showMedia(rootEl, variant.featured_media.id);
    var reqUrl = rootEl.getAttribute('data-product-url') + '?variant=' + variant.id + '&section_id=' + rootEl.getAttribute('data-section-id');
    fetch(reqUrl).then(function (r) { return r.text(); }).then(function (html) {
      var d = parseHTML(html);
      var newPrice = $('[data-price-block]', d), curPrice = $('[data-price-block]', rootEl);
      if (newPrice && curPrice) curPrice.innerHTML = newPrice.innerHTML;
      var newBtn = $('[data-add-to-cart]', d);
      if (newBtn && btn) { btn.disabled = newBtn.disabled; btn.innerHTML = newBtn.innerHTML; }
    }).catch(function () {});
  }

  /* ---------- Empfehlungen (lazy) ---------- */
  function initRecommendations(scope) {
    $$('[data-recommendations]', scope).forEach(function (el) {
      if (el.getAttribute('data-loaded') || $('.pcard', el)) return;
      el.setAttribute('data-loaded', 'true');
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = $('[data-recommendations]', parseHTML(html));
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }

  function syncCartTerms(scope) {
    $$('[data-cart-terms-checkbox]', scope).forEach(function (cb) {
    var container = cb.closest('[data-cart-terms-container]');
    var btn = container && $('[data-cart-terms-submit]', container);
    if (btn) btn.disabled = !cb.checked;
    });
    }

  function initAll(scope) { scope = scope || doc; initRecommendations(scope); syncCartTerms(scope); }

  /* ---------- Delegierte Events ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(doc.getElementById(opener.getAttribute('data-drawer-open')), opener); return; }

    var closer = t.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); return; }

    var cartLink = t.closest('[data-cart-open]');
    if (cartLink && VILOS.cartType === 'drawer' && $('#CartDrawer') && !$('[data-main-cart]')) {
    e.preventDefault(); openDrawer($('#CartDrawer'), cartLink); refreshCart(); return;
    }

    var step = t.closest('[data-qty-change]');
    if (step) {
      var wrap = step.closest('[data-qty]');
      var input = wrap && $('.qty__input', wrap);
      if (!input) return;
      var min = input.getAttribute('min') !== null && input.getAttribute('min') !== '' ? Number(input.getAttribute('min')) : 0;
      var next = Math.max(min, (Number(input.value) || 0) + Number(step.getAttribute('data-qty-change')));
      input.value = next;
      var line = input.getAttribute('data-line');
      if (line) queueLineChange(line, next);
      return;
    }

    var remove = t.closest('[data-cart-remove]');
    if (remove) { changeLine(remove.getAttribute('data-cart-remove'), 0); return; }

    var thumb = t.closest('[data-thumb]');
    if (thumb) { showMedia(thumb.closest('[data-gallery]') || doc, thumb.getAttribute('data-thumb')); return; }
  });

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('[data-ajax-add]')) { e.preventDefault(); addToCart(form); }
  if (form && form.matches && form.matches('[data-discount-form]')) { e.preventDefault(); var dInput = form.querySelector('[data-discount-input]'); var dCode = dInput && dInput.value.trim(); if (dCode) { window.location.href = '/discount/' + encodeURIComponent(dCode) + '?redirect=' + encodeURIComponent(R.cart || '/cart'); } }
      });

  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('.qty__input[data-line]')) { var q = Math.max(0, Number(t.value) || 0); t.value = q; queueLineChange(t.getAttribute('data-line'), q); return; }
    if (t.matches('[data-option-input]')) { var rootEl = t.closest('[data-product-root]'); if (rootEl) onVariantChange(rootEl); return; }
    if (t.matches('[data-cart-terms-checkbox]')) { var container = t.closest('[data-cart-terms-container]'); var btn = container && $('[data-cart-terms-submit]', container); if (btn) btn.disabled = !t.checked; }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = openDrawers();
      if (open.length) { closeDrawer(open[open.length - 1]); return; }
    }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.qty__input')) { e.preventDefault(); e.target.blur(); return; }
    if (e.key === 'Tab') {
      var drawers = openDrawers();
      if (!drawers.length) return;
      var focusable = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', drawers[0])
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initAll(doc); });
  else initAll(doc);
})();
